export enum PositionInTherapy {
  FirstInLine = "first-in-line",
  SecondInLine = "second-in-line",
  ThirdInLine = "third-in-line",
  NotReported = "not-reported",
}

export enum BenchmarkAuthority {
  GoldStandard = "gold-standard",
  StandardOfCare = "standard-of-care",
  NotEstablished = "not-established",
  NotReported = "not-reported",
}

export enum ModeOfUse {
  StandAlone = "stand-alone",
  Adjunctive = "adjunctive",
  NotReported = "not-reported",
}

export enum InnovationStatus {
  FirstInClass = "first-in-class",
  NotReported = "not-reported",
}

export type MedicalAlternative = {
  name?: string;
  description?: string;
  indications?: string[];
  contraindications?: string[];
  targetPopulation?: string[];
  assessment: {
    positionInTherapy?: PositionInTherapy;
    benchmarkAuthority?: BenchmarkAuthority;
    modeOfUse?: ModeOfUse;
    innovationStatus?: InnovationStatus;
  };
};

export type MedicalAlternativesValue = {
  alternatives: Array<MedicalAlternative>;
  equipoise?: boolean;
};

export type StudyDesignValue = import("visual-study-design-builder").StudyDesignExport;

export type AttributeValue = MedicalAlternativesValue | StudyDesignValue | null;
